import React, { useState , useEffect, useRef, useCallback} from 'react';
import PropTypes from 'prop-types';
import { Input } from 'app/components';
import { MapPin } from '@phosphor-icons/react';
import { venues } from '../mockdata';
import './style';
import { debounce } from 'lodash';
import { autoCompleteSearch } from '../../api';

const VenueDropdown = (props) => {
  const {
    updateSubStep,
    setFormData, 
    formData, 
    error, 
    setError,
  } = props;
  
  const [value, setValue] = useState(formData?.event_address?.name);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const dropdownRef = useRef(null);

  const [venuesList, setVenueList] = useState([]);

  useEffect(() => {
    autoCompleteSearch(formData?.geo_location || 'Chennai', formData?.event_address?.location?.lat ? `${formData.event_address.location.lat},${formData.event_address.location.lng}` : '13.067439,80.237617', (data) => {
      const preds = data?.data || [];
      const formattedSearchItems = preds.map((prediction) => {
        const addrLines = prediction?.structured_formatting?.secondary_text?.split(`, ${formData?.geo_location || 'Chennai'}`);
        return {
          name : prediction?.structured_formatting?.main_text,
          address_line_1: addrLines?.[0],
          address_line_2: '',
          city: `${formData?.geo_location || 'Chennai'}${addrLines?.slice(1, addrLines.length).join(', ')}`,
          place_id: prediction?.place_id,
          location: prediction?.geometry?.location,
        }
      });
      setVenueList(formattedSearchItems);
    });
  }, [formData?.geo_location]);
  
  const debouncedSearch = useCallback(
    debounce((searchValue) => {
      autoCompleteSearch(searchValue, formData?.event_address?.location?.lat ? `${formData.event_address.location.lat},${formData.event_address.location.lng}` : '13.067439,80.237617', (data) => {
        const preds = data?.data || [];
        const formattedSearchItems = preds.map((prediction) => {
          const addrLines = prediction?.structured_formatting?.secondary_text?.split(`, ${formData?.geo_location || 'Chennai'}`);
          return {
            name : prediction?.structured_formatting?.main_text,
            address_line_1: addrLines?.[0],
            address_line_2: '',
            city: `${formData?.geo_location || 'Chennai'}${addrLines?.slice(1, addrLines.length).join(', ')}`,
            place_id: prediction?.place_id,
            location: prediction?.geometry?.location,
          }
        });
        setVenueList(formattedSearchItems);
      });
    }, 500),
    [formData],
  );

  const handleChange = e =>{
    const value = e.target.value;
    setValue(value);
    debouncedSearch(value);
        
    // if(value === '') {
    //   setFormData({
    //     ...formData,
    //     venueSelected:false,
    //     event_address:{
    //       name:'',
    //       address_line_1:'',
    //       address_line_2:'',
    //       city:'',
    //     },
    //   })
    // }
  }

  const handleManualLocationChange = e =>{
    e.preventDefault();
    setFormData({
      ...formData,
      event_address: {
        ...formData?.event_address,
        name: '',
        address_line_1:'',
        address_line_2:'',
        city:'',
      },
    });
    updateSubStep((prev) => ({ step: prev?.step + 1, source: 'next' }));
  }

  const handleSelect = (venue) => {
    setValue(venue.name);
    
    setFormData({
      ...formData,
      event_address: {
        ...formData?.event_address,
        ...venue,
      },
    });
    setError((prev) => ({
      ...prev,
      venueSelectedError: '',
    }));
    setIsDropdownVisible(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownVisible(false);
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className='flex flex-col gap-2'>
      <Input
        width="100%" 
        label="Venue location"
        value={value}
        iconLeft={<MapPin size={24}
          weight="fill" />}
        validationStatus={error.venueSelectedError && 'error'}
        helpText={error.venueSelectedError}
        onChange={(e) => handleChange(e)}
        onFocus={() => setIsDropdownVisible(true)}
        onBlur={() => setIsDropdownVisible(false)}
      />
      {isDropdownVisible && (
        <div className='pb-6 flex flex-col gap-2 dropdown-container drop-shadow-lg h-[300px] overflow-y-scroll'>
          <div className='flex flex-col items-start self-stretch '>
            {venuesList.map((venue, index) => (
              <div 
                key={index} 
                className='px-[18px] py-4 flex items-center gap-3 self-stretch cursor-pointer dropdown-item'
                onMouseDown={() => handleSelect(venue)}
              >
                <div className='w-9 h-9 flex justify-center items-center rounded-full bg-grey-10'>
                  <MapPin size={24}
                    weight="fill" />
                </div>
                <div className='flex flex-col justify-center items-start gap-1 '>
                  <h1 className='label-16'>{venue.name}</h1>
                  <p className='text-14'>{`${venue.address_line_1}${venue.address_line_2 ? `, ${venue.address_line_2}` : ''}${venue.city ? `, ${venue.city}` : ''}`}</p>
                </div>
              </div>
            ))}
          </div>
          <div className='pl-[18px] flex gap-3'>
            <div className='w-9' >
              {'  '}
            </div>
            <div
              className='underline font-semibold cursor-pointer'
              onMouseDown={handleManualLocationChange}>
                Enter location manually
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

VenueDropdown.propTypes = {
  setCurrentScreen: PropTypes.func,
  setProgress: PropTypes.func,
  setFormData: PropTypes.func,
  formData: PropTypes.object,
  error: PropTypes.object,
  setError: PropTypes.func,
};

VenueDropdown.defaultProps = {
  setCurrentScreen: () => {},
  setProgress: () => {},
  setFormData: () => {},
  formData: {},
  error: {},
  setError: () => {},
};

export default VenueDropdown;
